module.exports = __webpack_public_path__ + "r-v3/img/ico_reload_white.fea27ca0.svg";